import { Navbar } from "@/components/layout/Navbar";
import { HeroSection } from "@/components/home/HeroSection";
import { PageSEO } from "@/hooks/usePageSEO";
import { lazy, Suspense, useEffect, useState } from "react";
import { MobileMenuProvider } from "@/contexts/MobileMenuContext";

// Lazy load below-fold sections to reduce initial JS bundle
const VoiceAISection = lazy(() => import("@/components/home/VoiceAISection").then(m => ({ default: m.VoiceAISection })));
const IndustrySolutionsSection = lazy(() => import("@/components/home/IndustrySolutionsSection").then(m => ({ default: m.IndustrySolutionsSection })));
const ChoosePathSection = lazy(() => import("@/components/home/ChoosePathSection").then(m => ({ default: m.ChoosePathSection })));
const PlatformIdentitySection = lazy(() => import("@/components/home/PlatformIdentitySection").then(m => ({ default: m.PlatformIdentitySection })));
const MotionOSSection = lazy(() => import("@/components/home/MotionOSSection").then(m => ({ default: m.MotionOSSection })));
const MotionOSInAction = lazy(() => import("@/components/motionos/MotionOSInAction"));
const AgentStoreSection = lazy(() => import("@/components/home/AgentStoreSection").then(m => ({ default: m.AgentStoreSection })));
const BusinessModulesSection = lazy(() => import("@/components/home/BusinessModulesSection").then(m => ({ default: m.BusinessModulesSection })));
const PricingPreviewSection = lazy(() => import("@/components/home/PricingPreviewSection").then(m => ({ default: m.PricingPreviewSection })));
const ScaleSignalsSection = lazy(() => import("@/components/home/ScaleSignalsSection").then(m => ({ default: m.ScaleSignalsSection })));
const TestimonialsSection = lazy(() => import("@/components/home/TestimonialsSection").then(m => ({ default: m.TestimonialsSection })));
const ExpertCTASection = lazy(() => import("@/components/home/ExpertCTASection").then(m => ({ default: m.ExpertCTASection })));
const FooterSection = lazy(() => import("@/components/layout/Footer").then(m => ({ default: m.Footer })));

const SectionFallback = () => <div className="py-20" />;

const Index = () => {
  const [deferredReady, setDeferredReady] = useState(false);

  useEffect(() => {
    let timeoutId: ReturnType<typeof setTimeout> | undefined;
    let idleId: number | undefined;

    if (typeof window === "undefined") {
      setDeferredReady(true);
      return;
    }

    if ("requestIdleCallback" in window) {
      const requestIdle = (window as any).requestIdleCallback as (cb: () => void, opts?: { timeout: number }) => number;
      idleId = requestIdle(() => setDeferredReady(true), { timeout: 800 });
    } else {
      timeoutId = setTimeout(() => setDeferredReady(true), 500);
    }

    return () => {
      if (idleId !== undefined && "cancelIdleCallback" in window) {
        (window as any).cancelIdleCallback(idleId);
      }
      if (timeoutId !== undefined) {
        clearTimeout(timeoutId);
      }
    };
  }, []);

  return (
    <MobileMenuProvider>
    <div className="min-h-screen bg-black">
      <PageSEO pageKey="home" />
      <Navbar />
      <main>
        <HeroSection />
        {deferredReady && (
          <Suspense fallback={<SectionFallback />}>
            <VoiceAISection />
            <IndustrySolutionsSection />
            <PlatformIdentitySection />
            <MotionOSSection />
            <MotionOSInAction />
            <AgentStoreSection />
            <BusinessModulesSection />
            <PricingPreviewSection />
            <ScaleSignalsSection />
            <TestimonialsSection />
            <ChoosePathSection />
            <ExpertCTASection />
          </Suspense>
        )}
      </main>
      {deferredReady && (
        <Suspense fallback={<SectionFallback />}>
          <FooterSection />
        </Suspense>
      )}
    </div>
    </MobileMenuProvider>
  );
};

export default Index;